
import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface DeleteDialogState {
  isOpen: boolean;
  type: 'single' | 'all';
  slotId?: string;
  dayOfWeek?: number;
  dayName?: string;
  timeSlot?: string;
}

interface DeleteConfirmDialogProps {
  deleteDialog: DeleteDialogState;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DeleteConfirmDialog({ deleteDialog, onConfirm, onCancel }: DeleteConfirmDialogProps) {
  return (
    <AlertDialog open={deleteDialog.isOpen} onOpenChange={(open) => !open && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>ยืนยันการลบ</AlertDialogTitle>
          <AlertDialogDescription>
            {deleteDialog.type === 'single' ? (
              <>
                คุณต้องการลบช่วงเวลา "{deleteDialog.timeSlot}" ในวัน{deleteDialog.dayName} ใช่หรือไม่?
              </>
            ) : (
              <>
                คุณต้องการลบช่วงเวลาทั้งหมดในวัน{deleteDialog.dayName} ใช่หรือไม่?
              </>
            )}
            <br />
            <span className="text-red-600 font-medium">การดำเนินการนี้ไม่สามารถยกเลิกได้</span>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>ยกเลิก</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-red-600 hover:bg-red-700">
            ลบ
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
